type Props = {
  fill?: string;
  height: string;
  width: string;
};

const FacebookIcon = ({ height, fill = '#4267B2', width }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H15.842V14.2456H18.4956L18.8928 11.2234H15.842V9.29362C15.842 8.41893 16.0895 7.82269 17.3687 7.82269L19 7.82195V5.11904C18.7176 5.08222 17.7495 5 16.6226 5C14.2706 5 12.6602 6.40839 12.6602 8.99476V11.2234H10V14.2456H12.6602V22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2Z"
        fill={fill}
      />
    </svg>
  );
};

export default FacebookIcon;
